'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = require('tslib');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var styles = require('@material-ui/core/styles');
var constants = require('./constants.js');

var useStyles = function (color, height) {
    if (color === void 0) { color = constants.COLORS; }
    if (height === void 0) { height = constants.HEIGHT; }
    return styles.makeStyles(function (theme) {
        var _a;
        return styles.createStyles({
            root: {
                backgroundColor: color.rootColor || styles.lighten(color.barColor, (_a = color.opacity) !== null && _a !== void 0 ? _a : 0.5),
                height: height,
                borderRadius: constants.BORDER_RADIUS,
            },
            bar: {
                backgroundColor: color.barColor,
            },
            label: {
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: 1,
                maxHeight: height + "px",
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                '& span': {
                    width: '100%',
                    '& p': {
                        color: color.labelColor,
                        fontFamily: theme.typography.fontFamily,
                    },
                },
            },
        });
    });
};
var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n"], ["\n  position: relative;\n  width: 100%;\n"])));
var templateObject_1;

exports.Container = Container;
exports.useStyles = useStyles;
